// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"770":"5e0c4f05","849":"aa2a5617"}[chunkId] + ".chunk.js";
};